import { Icon } from "@/components";
import React from "react";
import { BookingEventStep } from "./event_booking_container";

interface EventBookingStepTitleProps {
  step: BookingEventStep;
  title: string;
  isActive: boolean;
  isDone: boolean;
}

export function EventBookingStepTitle({
  step,
  title,
  isActive,
  isDone,
}: EventBookingStepTitleProps) {
  return (
    <div className="fw-semibold d-flex gap-2 align-items-center">
      {isDone ? (
        <Icon name="check-full-circle" size={20} color="var(--bs-primary)" />
      ) : (
        <div
          style={{
            fontSize: 12,
            width: "20px",
            height: "20px",
            color: isActive ? "var(--bs-primary)" : "black",
            border: `1px solid ${isActive ? "var(--bs-primary)" : "black"}`,
            borderRadius: 50,
          }}
          className="p-1 d-flex justify-content-center align-items-center"
        >
          {step}
        </div>
      )}
      <div style={{ flex: 1 }}>{title}</div>
    </div>
  );
}
